import * as React from 'react';
import { memo } from 'react';

import { warn } from 'helper/debug';
import noop from 'helper/noop';

export type CheckboxProps = {
	id: string;
	tag: string;
	name: string;
	label?: string;
	isChecked?: boolean;
	onChange: Function;
	modifier?: string;
	disabled?: boolean;
};

export type CheckboxState = {
	value: boolean;
};

class Checkbox extends React.Component<CheckboxProps, CheckboxState> {
	public static displayName = 'Checkbox';

	public static defaultProps = {
		onChange: noop,
	};

	public state = {
		value: false,
	};

	public handleChange(ev: Event) {
		if (ev && ev.target instanceof HTMLInputElement) {
			const checked = !!ev.target.checked;

			this.props.onChange.apply(null, [checked]);
			this.setState({
				value: checked,
			});
		}
	}

	public componentDidUpdate(prevProps): void {
		if (this.props.isChecked !== prevProps.isChecked) {
			const value = this.props.isChecked || false;
			this.setState({ value });
		}
	}

	public render() {
		const { id, name, label, tag, isChecked = false, modifier, disabled = false } = this.props;

		if (!tag) {
			warn(`No tag for checkbox ${id} defined`);
		}

		const Tag: any = `${tag}`; // JSX hack for custom Tags
		const checked = isChecked || this.state.value;
		const onChange = this.handleChange.bind(this);

		const propSet = {
			id,
			name,
			checked,
			onChange,
			disabled,
		};

		const classNames = ['a-checkbox'];

		if (modifier) {
			classNames.push(`${classNames[0]}--${modifier}`);
		}

		if (disabled) {
			classNames.push(`state-${classNames[0]}--disabled`);
		}

		return (
			<Tag className={classNames.join(' ')}>
				<input type="checkbox" {...(propSet as any)} />
				{label && <label htmlFor={id} dangerouslySetInnerHTML={{ __html: label }} />}
			</Tag>
		);
	}
}

export { Checkbox };
export default memo(Checkbox);
